import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/auth-context";

type CallToActionApiKeyProps = {
	className?: string;
};

export default function CallToActionApiKey({ className }: CallToActionApiKeyProps) {
	const { user } = useAuth();
	const target = user ? "/dashboard" : "/register";

	return (
		<section
			className={cn(
				"rounded-xl border-2 border-accent bg-white px-6 py-6 text-center shadow-md",
				className,
			)}
		>
			<div className="mx-auto max-w-2xl space-y-4">
				<h3 className="text-lg font-bold text-ink sm:text-xl">Don't have an API key yet?</h3>
				<p className="text-sm text-slate-700 sm:text-base">
					Get one and start formatting thousands of words with no charges.
				</p>
				<div className="pt-2">
					<Button asChild size="lg" className="h-11 min-w-44 px-7 text-base font-semibold shadow">
						<Link to={target}>Get free API key</Link>
					</Button>
				</div>
			</div>
		</section>
	);
}
